// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var MenuV5 = require("../../../common/Components/menu/MenuV5.bs.js");
var Scalars = require("../../../../scalars/Scalars.bs.js");
var UTCDate = require("../../../../reason/common/types/UTCDate.bs.js");
var ViewStack = require("../../../../reason/common/ViewStack.bs.js");
var Text__Jsx3 = require("../../../../uikit/reason/helpers/Text__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var DuplicatePropertyError = require("./DuplicatePropertyError.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PropertyAddressValidationCallout = require("./PropertyAddressValidationCallout.bs.js");
var DuplicateBroadcastRentalPropertyError_editableBroadcastRentalProperty_graphql = require("../../../../__generated__/DuplicateBroadcastRentalPropertyError_editableBroadcastRentalProperty_graphql.bs.js");

var convertFragment = DuplicateBroadcastRentalPropertyError_editableBroadcastRentalProperty_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, DuplicateBroadcastRentalPropertyError_editableBroadcastRentalProperty_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(DuplicateBroadcastRentalPropertyError_editableBroadcastRentalProperty_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, DuplicateBroadcastRentalPropertyError_editableBroadcastRentalProperty_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(DuplicateBroadcastRentalPropertyError_editableBroadcastRentalProperty_graphql.node, convertFragment, fRef);
}

var Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function DuplicateBroadcastRentalPropertyError(props) {
  var property = use(props.property);
  return JsxRuntime.jsxs(PropertyAddressValidationCallout.make, {
              heading: "You already have a property with this address on TAN",
              children: [
                JsxRuntime.jsx(Text__Jsx3.make, {
                      lineHeight: {
                        NAME: "float",
                        VAL: 1.50
                      },
                      children: JsxRuntime.jsxs("p", {
                            children: [
                              "You have already added a rental property at ",
                              JsxRuntime.jsx("strong", {
                                    children: property.address + ", " + property.area.label
                                  }),
                              " to TAN " + UTCDate.formatDistanceFromNow(true, Scalars.DateTime.toUTC(property.createdAt)) + " ago. ",
                              "Click below to view, edit, or rebroadcast it"
                            ]
                          })
                    }),
                JsxRuntime.jsxs(ViewStack.make, {
                      pt: "sm",
                      space: "sm",
                      justifyContent: "flexEnd",
                      flexDirection: "row",
                      children: [
                        JsxRuntime.jsx(DuplicatePropertyError.ViewClientButton.make, {
                              clientId: property.client.id
                            }),
                        JsxRuntime.jsxs(DuplicatePropertyError.ActionsDropdown.make, {
                              children: [
                                JsxRuntime.jsx(MenuV5.MenuItem.make, {
                                      href: "/properties/" + property.id + "/edit",
                                      children: "Edit Broadcast Rental Property"
                                    }),
                                JsxRuntime.jsx(MenuV5.MenuItem.make, {
                                      href: "/properties/" + property.id + "/broadcast",
                                      children: "Rebroadcast Rental Property"
                                    })
                              ]
                            })
                      ]
                    })
              ],
              icon: "Warning"
            });
}

var make = DuplicateBroadcastRentalPropertyError;

exports.Fragment = Fragment;
exports.make = make;
/* MenuV5 Not a pure module */
